import { HttpEventType } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import moment from 'moment';
import readXlsxFile from 'read-excel-file';
import { filter, firstValueFrom, Subscription } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { UserModel } from 'src/app/models/authentication/user.model';
import { StoreImportBalanceModel } from 'src/app/models/imports/store-balance-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { TransferStoreWorkshopDetailService } from 'src/app/services/maintenance/transfer-store-workshop-detail.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { CompanyService } from 'src/app/services/management/company.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-store-balances-import',
  templateUrl: './store-balances-import.component.html',
  styleUrls: ['./store-balances-import.component.scss'],
  standalone: false
})
export class StoreBalancesImportComponent implements OnInit {

  branchCode: number | null = null;
  branchId = 0;
  companyCode: number | null = null;
  companyId: number | null = null;
  errorStoreBalance: number = 0;
  eventFile: any;
  filters: ColumnResponseModel[] = [];
  formImport: FormGroup = new FormGroup({});
  nameFile: string = 'Ningún archivo seleccionado.';
  nameWindow: string = 'Importación Saldos Taller';
  isOpened: string | undefined = undefined;
  listBranches: any[] = [];
  listCompanies: any[] = [];
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  subscription: Subscription;
  url: string = "store-balances-import";
  userAuthenticated: UserModel = new UserModel();
  visibleTxt: boolean = false;
  storeBalanceAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;

  constructor(private branchService: BranchService,
    private companyService: CompanyService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private toastHandlerService: ToastHandlerService,
    private transferStoreWorkshopDetailService: TransferStoreWorkshopDetailService,
    private router: Router,
    private title: Title,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService,) {
    this.getAllLists();
  }

  ngOnInit() {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    const filters = localStorage.getItem(this.url);
    if (filters) this.filters = JSON.parse(filters);
    this.headerService.setTitle(this.nameWindow);
    this.getPermission();
    this.validateForm();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  attach() {
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      this.eventFile.target.value = '';
    }
  }

  downloadErrorsTxt() {
    if (!this.storeBalanceAlerts || this.storeBalanceAlerts.length === 0) {
      this.toastHandlerService.showToast('error', 'No hay alertas para exportar');
      return;
    }

    this.transferStoreWorkshopDetailService.exportImportErrors(this.storeBalanceAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionSaldosTaller_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast('error', 'Error al exportar el archivo');
      }
    });
  }

  downloadGuideImport() {
    this.transferStoreWorkshopDetailService.downloadGuideImportTransferStoreWorkshop().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaSaldosTaller.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  async getAllLists() {
    try {
      const [companies] = await Promise.all([
        firstValueFrom(this.companyService.getAllCompaniesForSelectAsync()),
      ]);
      this.listCompanies = companies;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getBranch(branchId: number) {
    if (branchId != null) {
      this.branchId = branchId;
      const branch = this.listBranches.find(x => x.value == branchId);
      this.branchCode = branch.code;
    } else {
      this.branchCode = null;
      this.branchId = 0;
    }
  }

  async getCompany(companyId: number | null) {
    if (companyId != null && companyId != 0) {
      this.companyId = companyId;
      const company = this.listCompanies.find(x => x.value == companyId);
      this.companyCode = company.code;
      this.listBranches = await firstValueFrom(this.branchService.GetAllBranchesByCompanyIdForSelectAsync(this.companyId));
    } else {
      this.companyId = null;
      this.companyCode = null;
      this.listBranches = [];
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  async getPermission() {
    let url = this.router.url as string
    url = url.substring(1);
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos por tipo de impuesto.', error);
    }
    this.getPermissionsForUserByWindow();
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
  }

  importStoreBalance() {
    this.storeBalanceAlerts = [];
    this.errorStoreBalance = 0;
    this.visibleTxt = false;
    Object.keys(this.formImport.controls).forEach(key => {
      const control = this.formImport.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formImport.valid) {
      let isOk: boolean = true;
      const input = document.getElementById("fileImport") as any;
      const rowsImports = new Array<StoreImportBalanceModel>();
      let row: StoreImportBalanceModel;
      let counter: number = 1, dateBalances: Date, workshopCode: number, articleCode: number,
        storeCode: number, quantity: number, devolutionConsecutive: number, devolutionDate: Date, costCenterCode: number;
      if (input.files[0]) {
        readXlsxFile(input.files[0]).then(async (rows) => {
          if (rows.length <= 1) {
            this.toastHandlerService.showToast('warning', `El archivo ingresado no tiene registros para importar.`);
            return;
          }
          rows.splice(0, 1);

          rows.forEach(element => {
            counter = counter + 1;
            let rowHasError = false;

            dateBalances = this.formImport.get("dateBalances")?.value;
            //A. Código Compañía:
            const companyCode = parseFloat(element[0] as string);
            if (isNaN(companyCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna A. El código de la Compañía no es válido. `;
              this.storeBalanceAlerts.push(alert);
              rowHasError = true;
            } else {
              if (companyCode != this.companyCode) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna A. La Compañía del archivo no es igual a la Compañía seleccionada.`;
                this.storeBalanceAlerts.push(alert);
                rowHasError = true;
              }
            }

            //B. Código Sucursal:
            const branchCode = parseFloat(element[1] as string);
            if (isNaN(branchCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna B. El código de la Sucursal no es válido. `;
              this.storeBalanceAlerts.push(alert);
              rowHasError = true;
            } else {
              if (branchCode != this.branchCode) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna B. La Sucursal del archivo no es igual a la Sucursal seleccionada.`;
                this.storeBalanceAlerts.push(alert);
                rowHasError = true;
              }
            }

            //C. Código Taller:
            workshopCode = parseFloat(element[2] as string);
            if (isNaN(workshopCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna C. El código del Taller no es válido.`;
              this.storeBalanceAlerts.push(alert);
              rowHasError = true;
            }

            //D. Código Artículo:
            articleCode = parseFloat(element[3] as string);
            if (isNaN(articleCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna D. El código del Articulo no es válido.`;
              this.storeBalanceAlerts.push(alert);
              rowHasError = true;
            }

            //E. Código Bodega:
            storeCode = parseFloat(element[4] as string);
            if (isNaN(storeCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter} , Columna E. El código de la Bodega no es válido.`;
              this.storeBalanceAlerts.push(alert);
              rowHasError = true;
            }

            //F. Cantidad:
            quantity = parseFloat(element[5] as string);
            if (isNaN(quantity)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna F. La cantidad no es válida.`;
              this.storeBalanceAlerts.push(alert);
              rowHasError = true;
            }

            //G. Número Devolución:
            devolutionConsecutive = parseFloat(element[6] as string);

            //H. Fecha Devolución:
            //Convierte fecha de string a Date
            const devolutionDateString = element[7] as string;
            if (devolutionDateString != null) {
              devolutionDate = moment(devolutionDateString, 'DD/MM/YYYY').toDate();
              if (!moment(devolutionDateString, 'DD/MM/YYYY').isValid()) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna H. El campo de fecha devolución no es válido.`;
                this.storeBalanceAlerts.push(alert);
                rowHasError = true;
              }
            }

            //I. Código Centro de Costos:
            costCenterCode = parseFloat(element[8] as string);

            if (!rowHasError) {
              row = new StoreImportBalanceModel(counter, this.branchId, dateBalances, workshopCode, articleCode, storeCode, quantity, devolutionConsecutive,
                devolutionDate, costCenterCode);
              rowsImports.push(row);
            } else {
              isOk = false;
            }
          });
          if (isOk && rowsImports.length > 0) {
            try {
              const response = await firstValueFrom(this.transferStoreWorkshopDetailService.importStoreBalance(rowsImports));
              this.loadPreInvoicingModel = response;
              this.storeBalanceAlerts = response?.alerts ?? [];
              this.errorStoreBalance = response?.preInvoicingStateId;
              if (this.errorStoreBalance === 1) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast(
                  'error',
                  'La importación terminó con errores, puede exportarlos si lo desea.',
                  'ERROR');
              } else if (this.storeBalanceAlerts.length > 0) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast('error', 'La importación terminó con alertas, puede exportarlas si lo desea');
              } else {
                this.visibleTxt = false;
                this.toastHandlerService.showToast('success', `La importación terminó exitosamente.`);
              }
              this.clearInputFile();
            } catch (error) {
              this.nameFile = 'Ningún archivo seleccionado.';
              console.error('Error al importar Saldos Taller', error);
            }
          } else {
            this.errorStoreBalance = 1;
            this.visibleTxt = true;
            this.toastHandlerService.showToast(
              'error',
              'La importación terminó con errores, puede exportarlos si lo desea'
            );
          }
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No ha seleccionado ningún archivo.'
        });
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      companyId: {
        required: 'La compañía es obligatoria.',
        min: 'La compañía es obligatiria.',
      },
      branchId: {
        required: 'La sucursal es obligatoria.',
        min: 'La sucursal es obligatiria.'
      },
      dateBalances: {
        required: 'La fecha es obligatoria.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formImport.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  validateForm() {
    this.formImport = this.formBuilder.group({
      companyId: [0, [Validators.required, Validators.min(1)]],
      branchId: [0, [Validators.required, Validators.min(1)]],
      dateBalances: [null, [Validators.required]]
    });
  }
}